import instance from "./instance";

const STATION_HISTORY_BASE_URL = 'station-history';

export function getStationsHistory(startDate, endDate, stationId) {
  return instance.get(`${STATION_HISTORY_BASE_URL}/statistics/?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&stationId=${stationId}`);
}
